<template lang="pug">
  .youtube-player.a-box-xs-16x9
    .a-box-content
      video-player(ref="videoPlayer" :options="playerOptions")

</template>

<script>
  require('videojs-youtube');
  import { videoPlayer } from 'vue-video-player';

  export default {
    name: "youtubePlayer",

    components: {
      videoPlayer
    },

    props: {
      videoCode: {
        type: String
      }
    },

    computed: {
      playerOptions() {
        return {
          fluid: true,
          techOrder: ['youtube'],
          sources: [{
            type: "video/youtube",
            src: "https://www.youtube.com/watch?v=" + this.videoCode
          }]
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  import 'video.js/dist/video-js.css'
  .youtube-player
    opacity 0
    
    &.ready
      opacity 100
    
    video
      width 100%
      height 100%
      opacity 0
      
</style>
